/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class MenuGridItemConfiguration extends DaoModel {
  constructor(
    guid,
    justifyContent,
    alignContent,
    borderWidth,
    borderTop,
    borderBottom,
    borderRight,
    borderLeft,
    paddingLeft,
    paddingTop,
    paddingRight,
    paddingBottom,
    hideTitle,
    useCustomFontSize,
    fontSizeThreshold,
    showMasterSaleFormat,
    useCustomFontColor,
    fontColor,
    textAlign,
    useBackgroundColor,
    backgroundColor,
    lineHeight,
    useLineHeight,
    useFontSizeRatio,
    fontSize,
    fontSizeUnit
  ) {
    super(guid);
    this.justifyContent = justifyContent || null;
    this.alignContent = alignContent || null;
    this.borderWidth = borderWidth;
    this.borderTop = borderTop;
    this.borderBottom = borderBottom;
    this.borderRight = borderRight;
    this.borderLeft = borderLeft;
    this.paddingLeft = paddingLeft;
    this.paddingTop = paddingTop;
    this.paddingRight = paddingRight;
    this.paddingBottom = paddingBottom;
    this.hideTitle = hideTitle;
    this.useCustomFontSize = useCustomFontSize;
    this.fontSizeThreshold = fontSizeThreshold;
    this.showMasterSaleFormat = showMasterSaleFormat;
    this.useCustomFontColor = useCustomFontColor;
    this.fontColor = fontColor || '#FFFFFF';
    this.textAlign = textAlign || 'left';
    this.useBackgroundColor = useBackgroundColor || false;
    this.backgroundColor = backgroundColor || '#FFFFFF';
    this.lineHeight = lineHeight;
    this.useLineHeight = useLineHeight;
    this.useFontSizeRatio = useFontSizeRatio;
    this.fontSize = fontSize;
    this.fontSizeUnit = fontSizeUnit;
  }

  static toInstance(props = {}) {
    return new MenuGridItemConfiguration(
      props.guid,
      props.justify_content,
      props.align_content,
      props.border_width,
      props.border_top,
      props.border_bottom,
      props.border_right,
      props.border_left,
      props.padding_left,
      props.padding_top,
      props.padding_right,
      props.padding_bottom,
      props.hide_title,
      props.use_custom_font_size,
      props.font_size_threshold,
      props.show_master_sale_format,
      props.use_custom_font_color,
      props.font_color,
      props.text_align,
      props.use_background_color,
      props.background_color,
      props.line_height,
      props.use_line_height,
      props.use_font_size_ratio,
      props.font_size,
      props.font_size_unit
    );
  }

  serialize() {
    return {
      ...super.serialize(),
      justify_content: this.justifyContent,
      align_content: this.alignContent,
      border_width: this.borderWidth,
      border_top: this.borderTop,
      border_bottom: this.borderBottom,
      border_right: this.borderRight,
      border_left: this.borderLeft,
      padding_top: this.paddingTop,
      padding_left: this.paddingLeft,
      padding_right: this.paddingRight,
      padding_bottom: this.paddingBottom,
      hide_title: this.hideTitle,
      use_custom_font_size: this.useCustomFontSize,
      font_size_threshold: this.fontSizeThreshold,
      show_master_sale_format: this.showMasterSaleFormat,
      use_custom_font_color: this.useCustomFontColor,
      font_color: this.fontColor,
      text_align: this.textAlign,
      use_background_color: this.useBackgroundColor,
      background_color: this.backgroundColor,
      line_height: this.lineHeight,
      use_line_height: this.useLineHeight,
      use_font_size_ratio: this.useFontSizeRatio,
      font_size: this.fontSize,
      font_size_unit: this.fontSizeUnit
    };
  }

  overwrite(menuGridItemConfiguration) {
    this.justifyContent = menuGridItemConfiguration.justifyContent;
    this.alignContent = menuGridItemConfiguration.alignContent;
    this.borderWidth = menuGridItemConfiguration.borderWidth;
    this.borderTop = menuGridItemConfiguration.borderTop;
    this.borderBottom = menuGridItemConfiguration.borderBottom;
    this.borderRight = menuGridItemConfiguration.borderRight;
    this.borderLeft = menuGridItemConfiguration.borderLeft;
    this.paddingLeft = menuGridItemConfiguration.paddingLeft;
    this.paddingTop = menuGridItemConfiguration.paddingTop;
    this.paddingRight = menuGridItemConfiguration.paddingRight;
    this.paddingBottom = menuGridItemConfiguration.paddingBottom;
    this.hideTitle = menuGridItemConfiguration.hideTitle;
    this.useCustomFontSize = menuGridItemConfiguration.useCustomFontSize;
    this.fontSizeThreshold = menuGridItemConfiguration.fontSizeThreshold;
    this.useFontSizeRatio = menuGridItemConfiguration.useFontSizeRatio;
    this.fontSize = menuGridItemConfiguration.fontSize;
    this.fontSizeUnit = menuGridItemConfiguration.fontSizeUnit;
    this.showMasterSaleFormat = menuGridItemConfiguration.showMasterSaleFormat;
    this.useCustomFontColor = menuGridItemConfiguration.useCustomFontColor;
    this.fontColor = menuGridItemConfiguration.fontColor;
    this.textAlign = menuGridItemConfiguration.textAlign;
    this.useBackgroundColor = menuGridItemConfiguration.useBackgroundColor;
    this.backgroundColor = menuGridItemConfiguration.backgroundColor;
    this.lineHeight = menuGridItemConfiguration.lineHeight;
    this.useLineHeight = menuGridItemConfiguration.useLineHeight;
    return this;
  }
}
